import { Pipe, PipeTransform } from '@angular/core';
import { camelCase, kebabCase, snakeCase, startCase } from 'lodash';

@Pipe({ name: 'toCase' })
export class ToCasePipe implements PipeTransform {

  public transform(s: string, format: string): string {
    switch (format) {
      case 'camel':
        return camelCase(s);
      case 'kebab':
        return kebabCase(s);
      case 'snake':
        return snakeCase(s);
      case 'start':
        return startCase(s);
      default:
        return s;
    }
  }
}
